module.exports = "https://cdn.realtymogul.com/static/media/icon_core.61d1faea.svg";